import { Moment } from "moment";
import { Currency } from "./currency";
import { Language } from "./language";
import { QuotationTemplateProduct } from "./quotation-template-product";
import { School } from "./school";
import { SystemUser } from "./system-user";

export class QuotationTemplate {

    constructor(
        public name: string,
        public description: string,
        public comment: string,
        public baseCurrency: Currency,
        public products: QuotationTemplateProduct[],
        public priceIncludes: string,
        public priceNotIncludes: string,
        public school: School,
        public language: Language,
        public secondCurrency?: Currency,
        public created?: Moment,
        public createdBy?: SystemUser,
        public lastModified?: Moment,
        public lastModifiedBy?: SystemUser,
        public isDeleted?: boolean,
        public id?: number
    ){}
}
